var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { Validators, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { RutValidator } from 'ng2-rut';
import { UserService } from '../../../services/user.service';
import { WizardComponent } from 'node_modules/angular-archwizard';
import * as FormActions from '../../../reducers/actions/forms.actions';
import { rutClean } from 'rut-helpers';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';
var RegistroComponent = /** @class */ (function () {
    function RegistroComponent(_userService, fb, rutValidator, spinner, dialog, store, _router, snackBar, claveUnicaService, data) {
        this._userService = _userService;
        this.fb = fb;
        this.rutValidator = rutValidator;
        this.spinner = spinner;
        this.dialog = dialog;
        this.store = store;
        this._router = _router;
        this.snackBar = snackBar;
        this.claveUnicaService = claveUnicaService;
        this.data = data;
        this.buscando = true;
        this.registro = true;
        console.log("DATA", data);
        this.userform = this.fb.group({
            busc_rut: ['', [Validators.required, rutValidator, Validators.minLength(8)]],
        });
        this.form = new FormGroup({
            rut: new FormControl(['', [Validators.required, rutValidator, Validators.minLength(8)]]),
            nombres: new FormControl('', [Validators.required, Validators.minLength(3)]),
            apellidoP: new FormControl('', [Validators.required, Validators.minLength(3)]),
            apellidoM: new FormControl('', [Validators.required, Validators.minLength(3)]),
            profesion: new FormControl(''),
            calle: new FormControl('', [Validators.required, Validators.minLength(3)]),
            numero: new FormControl('', [Validators.required, Validators.minLength(1), Validators.pattern(/[0-9]*/)]),
            complemento: new FormControl(''),
            telefono: new FormControl('', [Validators.required, Validators.minLength(7), Validators.maxLength(9), Validators.pattern(/[0-9]*/)]),
            region: new FormControl('', [Validators.required, Validators.minLength(1)]),
            comuna: new FormControl('', [Validators.required, Validators.minLength(1)]),
            email: new FormControl('', [Validators.required, Validators.minLength(3), Validators.email]),
            passwords: this.fb.group({
                password: new FormControl('', [Validators.required, Validators.minLength(4)]),
                repassword: new FormControl('', [Validators.required, Validators.minLength(4)])
            }, { validator: this.passwordConfirming }),
        });
    }
    RegistroComponent.prototype.ngOnInit = function () {
        this.resetearForm();
        this.getRegiones();
        this.getComunas();
        if (sessionStorage.getItem('identity-domCloud')) {
            this.identityData = this._userService.getIdentity();
            this.buscando = false;
            console.log(this.identityData);
            this.form.controls['rut'].setValue(this.identityData.rut + this.identityData.dv);
            this.form.controls['nombres'].setValue(this.identityData.nombres);
            this.form.controls['apellidoP'].setValue(this.identityData.apellidoP);
            this.form.controls['apellidoM'].setValue(this.identityData.apellidoM);
            this.form.controls['nombres'].disable();
            this.form.controls['apellidoP'].disable();
            this.form.controls['apellidoM'].disable();
        }
    };
    RegistroComponent.prototype.passwordConfirming = function (c) {
        if (c.get('password').value !== c.get('repassword').value) {
            return { mismatchedPasswords: true };
        }
    };
    RegistroComponent.prototype.buscarUsuario = function () {
        var _this = this;
        this.spinner.show();
        this.form.patchValue({
            rut: this.userform.value.busc_rut
        });
        this._userService.buscarUsuario(rutClean(this.userform.value.busc_rut)).subscribe(function (response) {
            if (response.message) {
                _this.spinner.hide();
                alert("Su usuario ya existe");
            }
            if (response.register) {
                _this.spinner.hide();
                _this.buscando = false;
                _this.registro = true;
            }
            if (response.update) {
                _this.spinner.hide();
                _this.buscando = false;
                _this.registro = false;
                console.log(response.data);
                _this.form.controls['nombres'].setValue(response.data.Sol_Nombres);
                _this.form.controls['apellidoP'].setValue(response.data.Sol_Apel_Pat);
                _this.form.controls['apellidoM'].setValue(response.data.Sol_Apel_Mat);
                _this.form.controls['profesion'].setValue(response.data.Sol_Profesion);
                _this.form.controls['calle'].setValue(response.data.Sol_Direc_Calle);
                _this.form.controls['numero'].setValue(response.data.Sol_Direc_Num);
                _this.form.controls['email'].setValue(response.data.Sol_Mail);
                _this.form.controls['telefono'].setValue(response.data.Sol_Fono);
            }
        }, function (error) {
            var e = JSON.parse(error._body);
            _this.spinner.hide();
        });
    };
    RegistroComponent.prototype.register = function () {
        var _this = this;
        if (this.registro) {
            if (this.form.valid) {
                this.spinner.show();
                this._userService.register(this.form).subscribe(function (response) {
                    _this.finishRegister();
                    _this.spinner.hide();
                    _this.resetearForm();
                }, function (error) {
                    var e = JSON.parse(error._body);
                    _this.spinner.hide();
                });
            }
            else {
                this.btnclicked = true;
                swal({
                    type: 'error',
                    title: "Aviso",
                    text: "El formulario no es válido, por lo tanto no se puede crear el usuario.",
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                    allowOutsideClick: false
                }).then(function () {
                    window.scroll(0, 0);
                });
            }
        }
        if (!this.registro) {
            this.form.controls.passwords.controls['password'].setValue('1234');
            this.form.controls.passwords.controls['repassword'].setValue('1234');
            if (this.form.valid) {
                console.log("aca", this.form.valid);
                this.spinner.show();
                this._userService.register(this.form).subscribe(function (response) {
                    _this.finishRegister();
                    _this.spinner.hide();
                    _this.resetearForm();
                }, function (error) {
                    var e = JSON.parse(error._body);
                    _this.spinner.hide();
                });
            }
            else {
                this.btnclicked = true;
                swal({
                    type: 'error',
                    title: "Aviso",
                    text: "El formulario no es válido, por lo tanto no se puede actualizar el usuario.",
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                    allowOutsideClick: false
                }).then(function () {
                    window.scroll(0, 0);
                });
            }
        }
    };
    RegistroComponent.prototype.getComunas = function () {
        var _this = this;
        this._userService.getComunas().subscribe(function (response) {
            console.log('getComunas response', response);
            _this.comunas = response;
        }, function (error) {
            var e = JSON.parse(error._body);
        });
    };
    RegistroComponent.prototype.getRegiones = function () {
        var _this = this;
        this._userService.getRegiones().subscribe(function (response) {
            console.log('getRegiones response', response);
            _this.regiones = response;
        }, function (error) {
            var e = JSON.parse(error._body);
        });
    };
    RegistroComponent.prototype.resetearForm = function () {
        this.form.controls['rut'].setValue('');
        this.form.controls['nombres'].setValue('');
        this.form.controls['apellidoP'].setValue('');
        this.form.controls['apellidoM'].setValue('');
        this.form.controls['profesion'].setValue('');
        this.form.controls['calle'].setValue('');
        this.form.controls['numero'].setValue('');
        this.form.controls['complemento'].setValue('');
        this.form.controls['telefono'].setValue('');
        this.form.controls['region'].setValue('');
        this.form.controls['comuna'].setValue('');
        this.form.controls['email'].setValue('');
        this.form.controls.passwords.controls['password'].setValue('');
        this.form.controls.passwords.controls['repassword'].setValue('');
    };
    RegistroComponent.prototype.cambiarComunas = function (region) {
        var _this = this;
        this.comunasFinal = [];
        var nRomanoRegion;
        var nRomanoComuna;
        this.regiones.data.forEach(function (elemento) {
            //console.log('elemento', elemento)
            if (_this.quitarTildes(elemento.fieldData.region) == _this.quitarTildes(_this.form.get('region').value)) {
                nRomanoRegion = elemento.fieldData.REG_Numero.toLowerCase();
            }
        });
        this.comunas.forEach(function (element) {
            nRomanoComuna = _this.quitarTildes(element.fieldData.COM_Region).split("-")[0]; //table comunas
            if (nRomanoRegion == nRomanoComuna) {
                _this.comunasFinal.push(element);
            }
            else {
            }
        });
        if (this.comunasFinal.length == 0) {
            console.log("campo region en tabla regiones ( " + nRomanoRegion + ") no coincide con la region en tabla comunas ( " + nRomanoComuna + ") ");
        }
        console.log('this.comunasFinal', this.comunasFinal);
    };
    RegistroComponent.prototype.quitarTildes = function (palabra) {
        palabra = palabra.toLowerCase();
        return palabra.replace(/á/gi, "a").replace(/é/gi, "e").replace(/í/gi, "i").replace(/ó/gi, "o").replace(/ú/gi, "u").replace(/ñ/gi, "n");
    };
    RegistroComponent.prototype.finishRegister = function () {
        this.dialog.closeAll();
    };
    RegistroComponent.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.dialog.closeAll();
                        this.store.dispatch(new FormActions.FormUpdate('0', ''));
                        sessionStorage.removeItem("identity-domCloud");
                        sessionStorage.removeItem("token-domCloud");
                        return [4 /*yield*/, this.claveUnicaService.logoutClaveUnica()];
                    case 1:
                        response = _a.sent();
                        console.log('Deslogeo exitoso:', response);
                        this.snackBar.open("Se ha cerrado sesión", "Cerrar", {
                            duration: 3000,
                        });
                        this.back();
                        return [2 /*return*/];
                }
            });
        });
    };
    RegistroComponent.prototype.back = function () {
        this._router.navigate(['/inicio']);
    };
    return RegistroComponent;
}());
export { RegistroComponent };
